const DivisionEnum = {
    Anesthesia: 'Anesthesia',
    Corporate: 'Corporate',
    CustomerCare: 'CustomerCare',
    CVO: 'CVO',
    Government: 'Government',
    HospitalMedicine: 'HospitalMedicine',
    InternalMedicineSubSpecialties: 'InternalMedicineSubSpecialties',
    Malpractice: 'Malpractice',
    Neurology: 'Neurology',
    PrimaryCare: 'PrimaryCare',
    Psychiatry: 'Psychiatry',
    Radiology: 'Radiology',
    SurgeryClinicBased: 'SurgeryClinicBased',
    SurgeryHospitalBased: 'SurgeryHospitalBased',
};

const ExcludedDivisionEnum = {
    EmergencyMedicine: 'EmergencyMedicine',
};

const TypeEnum = {
    CustomerCareGiftsFlowers: 'CustomerCareGiftsFlowers',
    MalpracticeCompFundStateCompfunds: 'MalpracticeCompFundStateCompfunds',
    PSYCMalpracticeCompFund: 'PSYCMalpracticeCompFund',
    UnidentifiedLicensing: 'UnidentifiedLicensing',
    LodgingSecurityDeposit: 'LodgingSecurityDeposit',
    AssociateTravelPrepaid: 'AssociateTravelPrepaid',
    AssociateTravelAccrued: 'AssociateTravelAccrued',
    Disputed: 'Disputed',
    IncidentalsRounding: 'IncidentalsRounding',
    Rebate: 'Rebate',
};

export { DivisionEnum, TypeEnum, ExcludedDivisionEnum };
